import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import BASE_URL from '../../config';

const initialState = {
  howtoGalleryImages: [],
  status: 'idle',
  error: null,
};

export const fetchHowToGallery = createAsyncThunk(
  'howtoGallery/fetchHowToGallery',
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetch(`${BASE_URL}/v1/howto-gallery/`, {
        method: 'GET',
      });

      if (!response.ok) {
        const errorDetails = await response.json();
        return rejectWithValue(errorDetails);
      }

      return response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const howtoGallerySlice = createSlice({
  name: 'howtoGallery',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchHowToGallery.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchHowToGallery.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.howtoGalleryImages = action.payload;
      })
      .addCase(fetchHowToGallery.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export default howtoGallerySlice.reducer;
